import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { useAuthentication } from "../../../Hooks/useAuthentication";
import "./header.css";
import UserActions from "../UserActions/UserActions";

const Header = () => {
  const { isAuthenticated } = useAuthentication();
  const navCollapseRef = useRef(null);

  const closeMenu = () => {
    const el = navCollapseRef.current;
    if (!el || !el.classList.contains("show")) return;
    const bsCollapse = window.bootstrap?.Collapse?.getInstance(el);
    if (bsCollapse) {
      bsCollapse.hide();
    } else {
      el.classList.remove("show");
    }
  };

  return (
    <nav id="header-quality" className="navbar navbar-expand-lg">
      <div className="container-fluid">
        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <div className="logo-wrapper">
            <img
              src="/assets/imgs/Sin fondo.png"
              alt="BubUp"
              className="header-logo"
            />
          </div>
        </Link>

        {/* Botón hamburguesa (mobile) */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menú colapsable — se cierra automáticamente al tocar cualquier opción */}
        <div
          className="collapse navbar-collapse"
          id="navbarSupportedContent"
          ref={navCollapseRef}
          onClick={closeMenu}
        >
          {isAuthenticated && (
            <div className="d-flex flex-wrap gap-2">
              <UserActions />
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;